<h3 mat-dialog-title>DP FMEA</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>FMEA report</mat-label>
            <input matInput type="text" name="report" [(ngModel)]="trailDocuFMEA.fmea_report">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Last FMEA date</mat-label>
            <input matInput type="date" name="last_date" [(ngModel)]="trailDocuFMEA.last_date">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Records checked?</mat-label>
            <mat-select name="records_checked" [(ngModel)]="fmea_findings_closed">
                @for (state of fmea_findings_closed_States; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Last trail date</mat-label>
            <input matInput type="date" name="last__trail_date" [(ngModel)]="trailDocuFMEA.last_dp_anual_trails_date">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Records checked?</mat-label>
            <mat-select name="records_checked" [(ngModel)]="trail_findings_closed">
                @for (state of trail_findings_closed_States; track state) {
                <mat-option [value]="state">{{state.expression}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark</mat-label>
            <textarea matInput type="text" name="remark" [(ngModel)]="trailDocuFMEA.remark"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailDocuFMEA" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>

